<template>
    <div class="betOptionInfo" v-bind:class="{ live: leg.isLive }">
        <div class="betOptionInfo_header">
            <div class="betOptionInfo_header_title">
                <strong class="optionTitle">
                    {{ leg.marketType.name }}
                </strong>
            </div>
        </div>
        <div class="betOptionInfo_option">
            <div class="optionContent">
                <ul class="optionContent_inner">
                    <li>
                        <strong class="optionTeam">
                            {{ leg.betTeam }}
                        </strong>
                    </li>
                    <li class="optionOddsGroup">
                        <span v-if="pointDisplay" class="optionOdds optionOdds-point">{{ pointDisplay }}</span>
                        <template v-if="liveScoreDisplay">
                            <span class="optionOdds optionOdds-at">@</span>
                            <span class="optionOdds optionOdds-point">{{ liveScoreDisplay }}</span>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, toRefs } from 'vue';
    import { useBetBuilderLegLiveScore } from '@/components/myBets/useBetBuilderLegLiveScore';
    import { getLegPointDisplay } from '@/core/lib/betBuilderHelper';
    import type { IBetBuilderLeg } from '@/interface/betBuilder';

    const props = defineProps<{
        leg: IBetBuilderLeg;
    }>();

    const { leg } = toRefs(props);
    const pointDisplay = computed(() => getLegPointDisplay(leg.value));
    const { liveScoreDisplay } = useBetBuilderLegLiveScore(leg);
</script>

<style scoped lang="scss">
@import "@/components/myBets/miniMyBets/BetOptionInfo";
</style>
